import React, { Component } from 'react';
import { ErrorInfo } from './ErrorInfo';

type State = { hasError: boolean; error?: any; errorInfo?: any };

export type GlobalAppError = {
  message: string;
  description?: string;
  infoStack?: string;
  infoError?: string;
  intoComponentError?: string;
};

export class ErrorBoundary extends Component<
  React.PropsWithChildren<{
    renderCustomError?: (err: GlobalAppError) => React.ReactNode;
  }>,
  State
> {
  state: State = { hasError: false };

  static getDerivedStateFromError(_error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // TODO sentry
    console.error(error, errorInfo);
    this.setState({ error, errorInfo, hasError: true });
  }

  render() {
    const { renderCustomError } = this.props;

    if (this.state.hasError) {
      let message = 'Nastala chyba v aplikaci';
      let description = this.state.error?.message;

      let infoStack;
      let infoError;
      let intoComponentError;

      if (this.state.error && this.state.error.stack) {
        infoStack = this.state.error.stack.toString();
      }
      if (this.state.error) {
        infoError = JSON.stringify(this.state.error, null, 4);
      }

      if (this.state.errorInfo) {
        if (this.state.errorInfo.componentStack) {
          intoComponentError = this.state.errorInfo.componentStack;
        } else {
          intoComponentError = JSON.stringify(this.state.errorInfo, null, 4);
        }
      }

      const globalAppError: GlobalAppError = {
        message,
        description,
        infoError,
        infoStack,
        intoComponentError,
      };

      if (renderCustomError) {
        return renderCustomError(globalAppError);
      } else {
        const children = (
          <>
            <pre>{globalAppError.infoStack}</pre>
            <pre>{globalAppError.infoError}</pre>
            <pre>{globalAppError.intoComponentError}</pre>
          </>
        );

        return (
          <ErrorInfo
            message={globalAppError.message}
            description={globalAppError.description}
            refreshAction
          >
            {children}
          </ErrorInfo>
        );
      }
    }

    return this.props.children;
  }
}
